export const SET_TEAMS_BY_TOURNAMENT = 'SET_TEAMS_BY_TOURNAMENT';
export const RESET_TEAMS_BY_TOURNAMENT = 'RESET_TEAMS_BY_TOURNAMENT';
export const SHOW_MODAL_SELECTOR_TEAMS = 'SHOW_MODAL_SELECTOR_TEAMS';
export const SELECT_TEAM_FROM_TOURNAMENT = 'SELECT_TEAM_FROM_TOURNAMENT'